import React, { Component } from 'react';
import Logo from '../../img/headerLogo.png';
import Logo_JRA from '../../img/JRA_Subsidy.png';
import i18n from '../../i18n'

class PCHeader extends Component { 

  constructor(props){
    super(props)
    this.state = {
        styles:{},
    }
  }

  //レスポンシブデザイン
  componentWillMount=()=>{
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  }

  handleResize=()=>{
      if(window.innerWidth > 1366){
          this.setState(
              {styles:fullHDStyles}
          )
      }else if(window.innerWidth <= 1366 && window.innerWidth> 1024){
          this.setState(
              {styles:halfHDStyles}
          )
      }
  }

  render(){
    return(
      <div id="header" style={this.state.styles.header}>
        <div className={"title"}>
          <a href="/">
          <img src={Logo} style={this.state.styles.logo}></img>
          <img src={Logo_JRA} style={this.state.styles.logoJRA}></img>
          </a>
          <nav>
            <div style={this.state.styles.ul}>
              <li style={this.state.styles.li}><a href="/" style={this.state.styles.a}>{i18n.t('header.home')}</a></li>
              <li style={this.state.styles.li}><a href="/#introduction" style={this.state.styles.a}>{i18n.t('header.about_process')}</a></li>
              <li style={this.state.styles.li}><a href="/#about_blockchain" style={this.state.styles.a}>{i18n.t('header.blockchain')}</a></li>
              <li style={this.state.styles.li}><a href="/#about_coin" style={this.state.styles.a}>{i18n.t('header.coin')}</a></li>
              <li style={this.state.styles.li}><a href="/stores/" style={this.state.styles.a}>{i18n.t('header.stores')}</a></li>
              <li style={this.state.styles.li}><a href="/restaurants/" style={this.state.styles.a}>{i18n.t('header.restaurants')}</a></li>
              <li style={this.state.styles.li}><a href="/#about_cultivation" style={this.state.styles.a}>{i18n.t('header.about_cultivation')}</a></li>
              <li style={this.state.styles.li}><a href="/#contact_us" style={this.state.styles.a}>{i18n.t('header.contact_us')}</a></li>
              <li style={this.state.styles.li}><a href="/#partners" style={this.state.styles.a}>{i18n.t('header.partners')}</a></li>
            </div>
          </nav>
        </div>
      </div>
    );
  }
}

const fullHDStyles = {
  header:{
    height:"180px"
  },
  logo:{
    position:"absolute",
    left:"5%",
    top:"7px",
    width:"45%"
  },
  logoJRA:{
    position:"absolute",
    left:"5%",
    top:"97px",
    height:"auto",
    width:"6%"
  },
  ul:{
    position:"absolute",
    right:"6%",
  },
  li:{
    paddingTop:"15px",
    paddingRight:"45px",
    display:"inline-block",
    textDecoration:"none",
    writingMode:"vertical-lr",
    fontSize:"17px",
  },
  a:{
    textDecoration:"none",
    color:"black",
  }
}

const halfHDStyles = {
  header:{
    height:"155px"
  },
  logo:{
    position:"absolute",
    left:"5%",
    top:"6px",
    width:"51%"
  },
  logoJRA:{
    position:"absolute",
    left:"5%",
    top:"80px",
    height:"11%",
    width:"9%"
  },
  ul:{
    position:"absolute",
    right:"6%",
  },
  li:{
    paddingTop:"15px",
    paddingRight:"30px",
    display:"inline-block",
    textDecoration:"none",
    writingMode:"vertical-lr",
    fontSize:"15px",
  },
  a:{
    textDecoration:"none",
    color:"black",
  }
}

export default PCHeader;